import { Col, Row } from "react-bootstrap";
import SkeletonBlock from "../../common/SkeletonBlock";

const card = { borderRadius: 12 };

export const TilesSkeleton = ({ count = 6 }: { count?: number }) => (
  <Row className="g-3" role="status" aria-label="Loading">
    {Array.from({ length: count }).map((_, i) => (
      <Col key={i} xs={6} md={4} xl={2}>
        <SkeletonBlock height={92} style={card} />
      </Col>
    ))}
  </Row>
);

export const TableSkeleton = () => (
  <div role="status" aria-label="Loading opponents">
    <Row className="g-3 mb-3">
      <Col xs={12} md={6}>
        <SkeletonBlock height={92} style={card} />
      </Col>
      <Col xs={12} md={6}>
        <SkeletonBlock height={92} style={card} />
      </Col>
    </Row>
    {Array.from({ length: 6 }).map((_, i) => (
      <SkeletonBlock key={i} height={42} className="mb-1" />
    ))}
  </div>
);

export const CardSkeleton = ({ height = 220 }: { height?: number }) => (
  <SkeletonBlock
    height={height}
    style={card}
  />
);

export const TwoCardsSkeleton = ({ height = 220 }: { height?: number }) => (
  <Row className="g-3" role="status" aria-label="Loading">
    <Col xs={12} md={6}>
      <SkeletonBlock height={height} style={card} />
    </Col>
    <Col xs={12} md={6}>
      <SkeletonBlock height={height} style={card} />
    </Col>
  </Row>
);
